import { qrEncode } from './qr-encode';

export class Controller {

    /** @ngInject */
    constructor($scope, WebSocket) {
        this.$scope = $scope;
        this.WebSocket = WebSocket;
    }

    $onInit() {
        this.loadQrImage();
        this.WebSocket.connect();
        this.$scope.$on('websocket.disconnected', () => {
            this.$scope.$on('websocket.connected', () => this.loadQrImage());
        });
    }

    reConnect() {
        this.WebSocket.connect();
    }

    loadQrImage() {
        this.isLoading = true;
        this.loadQrData()
            .then((data) => {
                if (this.encoded) {
                    this.qrImage = `data:image/png;base64,${data}`
                } else {
                    this.qrImage = qrEncode(data);
                }
            })
            .finally(() => this.isLoading = false);
    }
}



// WEBPACK FOOTER //
// ./src/modules/reverse-ajax/sp-qr/sp-qr.controller.js